export const feedbacksSchema = {
	title: 'Feedbacks schema',
	version: 1,
	primaryKey: 'legId',
	type: 'object',
	properties: {
		legId: {
			type: 'string',
			maxLength: 300,
		},
		driverCarDetails: {
			type: 'object',
			properties: {
				displayName: {
					type: 'string',
				},
				carLicensePlate: {
					type: 'string',
				},
			},
			required: ['displayName', 'carLicensePlate'],
		},
		feedback: {
			oneOf: [
				{ type: 'null' },
				{
					type: 'object',
					properties: {
						feedbackId: {
							type: 'string',
						},
						bookingLegId: {
							type: 'string',
						},
						rating: {
							type: 'number',
						},
						comment: {
							type: 'string',
						},
					},
					required: ['feedbackId', 'bookingLegId', 'rating', 'comment'],
				},
			],
		},
	},
	required: ['legId', 'driverCarDetails'],
};
